// Shared gzip helpers for the opaque-payload transports (replay chunks,
// heatmap DOM snapshots). Callers guard with supports('compressionStream')
// before taking the gzip path.

// gzip a string via CompressionStream.
export function gzip(str) {
  const cs = new CompressionStream('gzip');
  const writer = cs.writable.getWriter();
  writer.write(strBytes(str));
  writer.close();
  return new Response(cs.readable).arrayBuffer().then((ab) => new Uint8Array(ab));
}

export function strBytes(str) {
  return new TextEncoder().encode(str);
}
